module.exports = "/work-site/img/car.ceedfe2d.png";